import { BASEURL } from '../../Constants';

export async function SendSignupLink(email) {
  

  try {
    const response = await fetch(`${BASEURL}/user/register/link`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email
      }),
    });

    const result = await response.json();
    return result;

  } catch (error) {
    return { success: false, message: 'An error occurred. Please try again.' };
  }
}